import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../Stores/store';
import { NavBarLink } from './NavBarLink';
import MobileNavBar from './MobileNavBar';
import DesktopNavBar from './DesktopNavBar';
import './NavBar.scss';
import { UserType } from '../../Models/UserType';

const NavBar = observer(() => {
    const { generalStore } = useStore();
    const { setIsMobile, isMobile, userType } = generalStore;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth);
        };
    
        handleResize();
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    const dayGuestlinks : NavBarLink[] = [
        { title: "Home", href:"/app" },
        { title: "About", href: "/app/about" },
        { title: "Agenda", href: "/app/agenda" },
        { title: "Menu", href: "/app/menu" },
        { title: "accommodation", href: "/app/accommodation" },
        { title: "FAQs", href: "/app/faqs"},
        { title: "Gifting", href: "/app/gifting" },
        { title: "Contact", href: "/app/contact" },
        { title: "RSVP", href: "/app/rsvp" }
    ]

    const eveningGuestLinks : NavBarLink[] = [
        { title: "Home", href:"/app" },
        { title: "About", href: "/app/about" },
        { title: "Agenda", href: "/app/agenda" },
        { title: "accommodation", href: "/app/accommodation" },
        { title: "FAQs", href: "/app/faqs"},
        { title: "Contact", href: "/app/contact" },
        { title: "Gifting", href: "/app/gifting" },
        { title: "RSVP", href: "/app/rsvp" }
    ];

    const links = userType === UserType.DayGuest ? dayGuestlinks : eveningGuestLinks;

    return (
        isMobile ? <MobileNavBar links={links} /> : <DesktopNavBar links={links} />
    )
});

export default NavBar;
